module.exports = __webpack_public_path__ + "static/TT-Floorplan-Floor28-2af4078d7d29050a99a9480d6330818f.jpg";